<template>
  <div :class="['common-dialog', messageDialogStore.status]" v-if="messageDialogStore.isVisible">
    <div class="common-dialog-overlay" />
    <div class="common-dialog-container">
      <div class="common-dialog-container-header">
        <div
          class="common-dialog-container-header-icon"
          v-if="messageDialogStore.status !== 'notice'"
        >
          <img
            v-if="messageDialogStore.status === 'error'"
            class="icon-error"
            src="@/assets/img/icon/dialog/error@2x.png"
            :alt="messageDialogStore.status"
          />
          <img
            v-if="messageDialogStore.status === 'caution'"
            class="icon-caution"
            src="@/assets/img/icon/dialog/caution@2x.png"
            :alt="messageDialogStore.status"
          />
        </div>
        <div class="common-dialog-container-header-title">
          <span>{{ messageDialogStore.title }}</span>
        </div>
      </div>

      <div class="common-dialog-container-message">
        <div v-if="messageDialogStore.htmlMessage" v-html="messageDialogStore.htmlMessage" />
        <span v-else>{{ messageDialogStore.message }}</span>
      </div>

      <div class="common-dialog-container-buttons">
        <div
          class="btn cancel"
          v-if="messageDialogStore.cancelButton"
          @click="clickCancel('cancel')"
        >
          <span class="cancel_font">{{ t('dialog.cancel') }}</span>
        </div>
        <div class="btn ok" @click="clickOk('ok')">
          <span class="ok_font">{{ t('dialog.ok') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import StoreUtil from '@/stores/StoreUtil'

export default defineComponent({
  name: 'MessageDialog',
  setup() {
    const messageDialogStore = StoreUtil.useStore('MessageDialogStore')
    return {
      messageDialogStore,
      ...useI18n(),
      /**
       * ダイアログのOKボタンがクリックされると呼び出される。
       */
      clickOk() {
        messageDialogStore.close('OK')
      },
      /**
       * ダイアログのキャンセルボタンがクリックされると呼び出される。
       */
      clickCancel() {
        messageDialogStore.close('Cancel')
      },
    }
  },
})
</script>

<style lang="scss" scoped>
.common-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10001;
  &-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: -1;
  }
  &-container {
    width: 520px;
    position: relative;
    overflow: hidden;
    background-color: rgb(230, 230, 230);
    border-radius: 5px;
    font-size: 12px;
    margin: 0 20px;

    &-header {
      height: 40px;
      display: flex;
      align-items: center;
      background: rgb(200, 200, 200);
      border-bottom: 1px rgba(170, 170, 170, 1) solid;
      padding-left: 14px;
      color: #000;
      &-icon {
        display: flex;
        align-items: center;
        margin-right: 9px;
        .icon-error {
          width: 18px;
          height: 18px;
        }
        .icon-caution {
          width: 18px;
          height: 16px;
        }
      }
      &-title {
        max-width: 465px;
        max-height: 34px;
        overflow: hidden;
      }
    }
    &-message {
      padding: 15px 20px;
      color: rgb(40, 40, 40);
    }
    &-buttons {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .btn {
        height: 40px;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 5px;
        border-radius: 5px;
        cursor: pointer;
      }
      .ok {
        width: 140px;
        background: rgb(60, 60, 60);
        color: #fff;
      }
      .cancel {
        width: 120px;
        background: rgb(230, 230, 230);
        border: 1px rgba(60, 60, 60, 1) solid;
        color: rgba(60, 60, 60, 1);
      }
      .btn_link {
        align-items: center;
        color: inherit;
        display: flex;
        height: 100%;
        justify-content: center;
        line-height: 1;
        position: relative;
        width: 100%;
      }
      .ok_font {
        color: #fff;
      }
      .cancel_font {
        color: rgba(60, 60, 60, 1);
      }
    }
  }
}
</style>
